import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { checkInKrQualMonth, getKrQualCheckInHalfMonth, reset } from 'app/entities/checkIn/checkIn.reducer';
import { checkInKrQualHalfMonthAdjust } from 'app/entities/kr/kr-qualitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';

type IReportQualitativeResult = {
  handleClose: (isReload?: boolean) => void;
  krCheckIn?: any;
  handleNextData: () => void;
  hideNextKr: boolean;
};

export const ReportQualitativeResult = ({ handleClose, krCheckIn, handleNextData, hideNextKr }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkIn.entity);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  const modalContentRef = useRef(null);

  // watch values form
  const workStatusMonthValues = Form.useWatch('workStatus', form);

  useEffect(() => {
    if (krCheckIn && filters) {
      form.resetFields();
      innitData();
    }
  }, [krCheckIn]);

  useEffect(() => {
    if (entity) {
      if (entity?.keyResultHalfMonth) {
        form.setFieldValue('workStatus', entity?.keyResultHalfMonth?.workStatus)
        form.setFieldValue('completeNote', entity?.keyResultHalfMonth?.completeNote)
        form.setFieldValue('unFinishNote', entity?.keyResultHalfMonth?.unFinishNote)
        form.setFieldValue('completedOn', entity?.keyResultHalfMonth?.completedOn !== null ? dayjs(entity?.keyResultHalfMonth?.completedOn) : null)
        form.setFieldValue('expectedCompleteOn', entity?.keyResultHalfMonth?.expectedCompleteOn != null ? dayjs(entity?.keyResultHalfMonth?.expectedCompleteOn) : null)
      }
      if (entity?.adjustment) {
        form.setFieldValue('issue', entity?.adjustment?.adjustmentIssue)
        form.setFieldValue('adjustmentNote', entity?.adjustment?.adjustmentNote)
        form.setFieldValue('solution', entity?.adjustment?.adjustmentSolution)
      }
    }
  }, [entity]);

  const innitData = () => {
    dispatch(getKrQualCheckInHalfMonth({ krId: krCheckIn?.id, planPeriodId: filters?.planPeriodId }));
  };

  const MapperPayload = (values: any) => {
    const valueMonth = {
      reportScheduleId: entity?.reportScheduleId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.planPeriodId,
      workStatus: values.workStatus,
      completedOn: values.completedOn != null ? dayjs(values.completedOn).format(APP_LOCAL_DATE_FORMAT_PAYLOAD) : null,
      expectedCompleteOn: values.expectedCompleteOn != null ? dayjs(values.expectedCompleteOn).format(APP_LOCAL_DATE_FORMAT_PAYLOAD) : null,
      completeNote: values.completeNote,
      unFinishNote: values.unFinishNote,
    };
    const valueAdjustment = {
      solution: values.solution,
      adjustmentNote: values.adjustmentNote,
      issue: values.issue,
      krId: krCheckIn?.id,
      sendingNotification: values.sendingNotification,
    };
    return { valueMonth, valueAdjustment };
  };

  const handleSubmit = values => {
    const { valueMonth, valueAdjustment } = MapperPayload(values);
    setUpdating(true);
    Promise.all([
      dispatch(checkInKrQualMonth(valueMonth)),
      dispatch(checkInKrQualHalfMonthAdjust(valueAdjustment)),
    ])
      .then(response => {
        const isFailed = _.some(response, o => {
          return !o.payload;
        });
        if (isFailed) return;
        form.resetFields();
        handleClose(true);
      })
      .catch(() => {
        return;
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        const { valueMonth, valueAdjustment } = MapperPayload(values);
        setUpdating(true);
        Promise.all([
          dispatch(checkInKrQualMonth(valueMonth)),
          dispatch(checkInKrQualHalfMonthAdjust(valueAdjustment)),
        ])
          .then(response => {
            const isFailed = _.some(response, o => {
              return !o.payload;
            });
            if (isFailed) return;
            dispatch(reset());
            form.resetFields();
            form.scrollToField('reportScheduleName');
            handleNextData();
          })
          .catch(() => {
            return;
          })
          .finally(() => {
            setUpdating(false);
          });
      })
      .catch((err) => {
        return err;
      })
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  return (
    <Spin delay={500} spinning={isUpdating}>
      <Form ref={modalContentRef} size="large" form={form} className='fw-bold' onFinish={handleSubmit} layout="vertical">
        <Title className="fw-bold" level={2}>
          {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
        </Title>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch">
              <Input className="w-100" disabled value={entity?.planPeriodName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo">
              <Input size='large' value={entity?.reportScheduleName} readOnly />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label={`Mục tiêu - ${entity?.objective?.code}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col className="fw-bold h3" md={24}>
            {`Kết quả cần đạt được - ${entity?.keyResultYear?.code}`}
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label={`KR ${entity?.keyResultYear?.name}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.keyResultYear?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultYear?.startDate)}
                placeholder="Chọn ngày bắt đầu"
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultYear?.dueDate)}
                placeholder="Chọn thời hạn hoàn thành"
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={11}>
            <Form.Item label={`KR ${entity?.keyResultQuarter?.name}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.keyResultQuarter?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultQuarter?.startDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultQuarter?.dueDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={11}>
            <Form.Item label={`KR ${entity?.keyResultMonth?.name}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.keyResultMonth?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Ngày bắt đầu">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultMonth?.startDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Thời hạn hoàn thành">
              <DatePicker
                className="w-100"
                disabled
                value={dayjs(entity?.keyResultMonth?.dueDate)}
                size="large"
                format={APP_LOCAL_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            {entity?.keyResultHalfMonth?.name}
          </Col>
        </Row>
        <Row>
          <Col md={7}>
            <Form.Item label="Tình trạng"
              rules={[{ required: entity?.keyResultMonth?.purpose ? true : false, message: 'Hãy chọn tình trạng' }]}
              name="workStatus">
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          {workStatusMonthValues === StatusType.Completed ? (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành`}
                rules={[
                  {
                    required: workStatusMonthValues === StatusType.Completed,
                    message: `Hãy chọn ngày hoàn thành`,
                  },
                ]}
                name={`completedOn`}
              >
                <DatePicker
                  minDate={dayjs(entity?.keyResultHalfMonth?.startDate)}
                  maxDate={dayjs(entity?.keyResultHalfMonth?.dueDate)}
                  size="large"
                  format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành`} className="w-100" />
              </Form.Item>
            </Col>
          ) : undefined}
          {(workStatusMonthValues === StatusType.NotStarted || workStatusMonthValues === StatusType.OnTrack) ? (
            <Col md={7}>
              <Form.Item
                label={`Ngày hoàn thành dự kiến`}
                rules={[
                  {
                    required: workStatusMonthValues && (workStatusMonthValues === StatusType.NotStarted || workStatusMonthValues === StatusType.OnTrack),
                    message: `Hãy chọn ngày hoàn thành dự kiến`,
                  },
                ]}
                name={`expectedCompleteOn`}
              >
                <DatePicker
                  size="large" format={APP_LOCAL_DATE_FORMAT} placeholder={`chọn ngày hoàn thành dự kiến`} className="w-100" />
              </Form.Item>
            </Col>
          ) : undefined}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item
              label="Đã hoàn thành"
              rules={[
                {
                  required: workStatusMonthValues === StatusType.Completed,
                  message: `Hãy nhập nội dung đã hoàn thành`,
                },
              ]}
              name={'completeNote'}
            >
              <TextArea rows={6} placeholder="Nhập nội dung đã hoàn thành" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item
              label="Nội dung chưa hoàn thành, lý do Tạm dừng, Hủy"
              rules={[
                {
                  required: workStatusMonthValues && workStatusMonthValues !== StatusType.Completed,
                  message: `Hãy nhập lý do`,
                },
              ]}
              name={'unFinishNote'}
            >
              <TextArea rows={6} placeholder="Nhập lý do" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
              <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
              <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'adjustmentNote'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
            <Form.Item valuePropName="checked" name={'sendingNotification'}>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            {!hideNextKr &&
              <Col>
                <Button
                  className="green"
                  onClick={() => {
                    handleNextKr();
                  }}
                  disabled={isUpdating}
                >
                  Lưu & Chuyển sang check in KR khác
                </Button>
              </Col>
            }
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            planPeriodType={filters?.planPeriodType}
            krTypeRequest={krCheckIn?.krType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
      </Form>
    </Spin>
  );
};

export default ReportQualitativeResult;
